import '@/assets/css/main.css';

import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import ui from '@nuxt/ui/vue-plugin';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import { initSentry } from '@/lib/sentry';
import { registerPlugins } from '@/plugins';
import router from '@/router';
import { useAuthStore } from '@/stores';

export const apiUrl = import.meta.env.VITE_SUICH_API_URL;
export const mapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
registerPlugins(app);
app.use(ui);

initSentry(app, router);

const defaultDocumentTitle = 'Suich';

router.afterEach((to) => {
  document.title = to.meta?.title
    ? `${to.meta.title} — ${defaultDocumentTitle}`
    : defaultDocumentTitle;
});

// Wait for router AND session restoration before mount
router.isReady().then(async () => {
  const auth = useAuthStore();
  await auth.init(); // Restore Better Auth session (from cookie)
  app.mount('#app');

  if (mapsApiKey) {
    setOptions({ key: mapsApiKey });
    await importLibrary('maps');
  }
});
